import { useState, useEffect } from "react";
import axios from "axios";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

const OrgForgotPasswordScreen = () => {
  const [ctEmail, setCtEmail] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const forgotPasswordHandler = async (e) => {
    e.preventDefault();

    const config = {
      header: {
        "Content-Type": "application/json",
      },
    };

    await axios.post(
      "/auth/org-forgot-password",
      { ctEmail },
      config
    ).then(
      () => {
        window.alert("Password reset email sent. Please check your inbox.");
      }
    ).catch(
      () => {
        window.alert("Password reset failed.");
      }
    )
  };

  return (
    <Container className="auth-page">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="auth-card">
            <Card.Body>
              <Form onSubmit={forgotPasswordHandler}>
                <h3 className="page-title">Organisation Forgot Password</h3>
                <p className="page-subtitle mb-4">Enter your contact email and we will send a password reset link.</p>
                <Form.Group className="mb-4" controlId="formEmail">
                  <Form.Label>Contact Email</Form.Label>
                  <Form.Control type="email" required placeholder="Email address" value={ctEmail} onChange={(e) => setCtEmail(e.target.value)} tabIndex={1}/>
                </Form.Group>
                <Button variant="primary" type="submit">
                  Send Email
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default OrgForgotPasswordScreen;
